// src/services/apiFetch.ts
import { API_BASE_URL } from './api';

export const apiFetch = async (endpoint: string, options: RequestInit = {}) => {
  const token = localStorage.getItem('adminToken');
  const finalHeaders = new Headers(options.headers || {});
  finalHeaders.set('Content-Type', 'application/json');

  if (token) {
    finalHeaders.set('Authorization', `Bearer ${token}`);
  }

  console.log("📦 apiFetch called:", endpoint);
  console.log("🧩 Headers:", Object.fromEntries(finalHeaders.entries()));

  const response = await fetch(
    endpoint.startsWith('http') ? endpoint : `${API_BASE_URL}${endpoint}`,
    {
      ...options,
      headers: finalHeaders,
    }
  );

  return response;
};
